<p-radioButton [styleClass]="'cap-radio'"
               [value]="radioValue"
               [name]="name" [(ngModel)]="value"
               [disabled]="disabled"
               [label]="label">
</p-radioButton>
